import React, { useState, useEffect } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { getImageUrl, PLACEHOLDER_IMAGE } from '../utils/imageUrl';
import './ImageCarousel.css';

const ImageCarousel = ({ images = [], autoPlay = true, interval = 5000, showControls = true }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(autoPlay);

  // Se não houver imagens fornecidas, usar um único slide padrão (placeholder local, sem depender de rede externa)
  const defaultImages = [
    {
      id: 1,
      image: getImageUrl(PLACEHOLDER_IMAGE),
      title: '',
      subtitle: ''
    }
  ];

  const carouselImages = images.length > 0 ? images : defaultImages;

  useEffect(() => {
    if (!isPlaying || carouselImages.length === 0) return;

    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => 
        prevIndex === carouselImages.length - 1 ? 0 : prevIndex + 1
      );
    }, interval);

    return () => clearInterval(timer);
  }, [isPlaying, carouselImages.length, interval]);

  const goToPrevious = () => {
    setCurrentIndex(currentIndex === 0 ? carouselImages.length - 1 : currentIndex - 1);
    setIsPlaying(false);
  };

  const goToNext = () => {
    setCurrentIndex(currentIndex === carouselImages.length - 1 ? 0 : currentIndex + 1);
    setIsPlaying(false);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
    setIsPlaying(false);
  };

  if (carouselImages.length === 0) {
    return null;
  }

  return (
    <div className="image-carousel">
      <div className="carousel-container">
        {showControls && (
          <button 
            className="carousel-button carousel-button-prev"
            onClick={goToPrevious}
            aria-label="Anterior"
          >
            <FaChevronLeft />
          </button>
        )}

        <div className="carousel-slides">
          {carouselImages.map((item, index) => (
            <div
              key={item.id || index}
              className={`carousel-slide ${index === currentIndex ? 'active' : ''}`}
            >
              <div className="carousel-image-wrapper">
                <img 
                  src={getImageUrl(item.image || item.foto) || item.image || item.foto}
                  alt={item.title || item.nome || `Slide ${index + 1}`}
                  onError={(e) => {
                    e.target.src = getImageUrl(PLACEHOLDER_IMAGE);
                  }}
                />
                {(item.title || item.subtitle) && (
                  <div className="carousel-overlay">
                    <div className="carousel-content">
                      {item.title && <h2 className="carousel-title">{item.title}</h2>}
                      {item.subtitle && <p className="carousel-subtitle">{item.subtitle}</p>}
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {showControls && (
          <button
            className="carousel-button carousel-button-next"
            onClick={goToNext}
            aria-label="Próximo"
          >
            <FaChevronRight />
          </button>
        )}
      </div>

      {showControls && (
        <div className="carousel-dots">
          {carouselImages.map((_, index) => (
            <button
              key={index}
              className={`carousel-dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Ir para slide ${index + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ImageCarousel;

